import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ContentType, ReportStatus } from '@/hooks/useContentModeration';

interface ReportFiltersProps {
  status: ReportStatus | 'all';
  contentType: ContentType | 'all';
  onStatusChange: (status: ReportStatus | 'all') => void;
  onContentTypeChange: (type: ContentType | 'all') => void;
}

export function ReportFilters({
  status,
  contentType,
  onStatusChange,
  onContentTypeChange,
}: ReportFiltersProps) {
  return (
    <div className="space-y-4 mb-6">
      <Tabs value={status} onValueChange={(v) => onStatusChange(v as ReportStatus | 'all')}>
        <TabsList>
          <TabsTrigger value="all">All</TabsTrigger>
          <TabsTrigger value="pending">Pending</TabsTrigger>
          <TabsTrigger value="reviewed">Reviewed</TabsTrigger>
        </TabsList>
      </Tabs>

      <div className="flex gap-4">
        <Select value={contentType} onValueChange={(v) => onContentTypeChange(v as ContentType | 'all')}>
          <SelectTrigger className="w-[200px]">
            <SelectValue placeholder="Content type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="review_comment">Review Comments</SelectItem>
            <SelectItem value="activity_comment">Activity Comments</SelectItem>
            <SelectItem value="message">Messages</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
